import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";
// import { getMentorForms } from "./dependencies/action";
import { makeStyles } from "@material-ui/core/styles";
import applyIcon from "../../assets/images/close_icon.svg";
import "./styles.scss";
import {
  Typography,
  // TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
} from "@material-ui/core";
import MentorFillupForm from "./MentorFillupForm";
import formbg from "../../assets/images/form-bg.jpg";

import { CssBaseline, Container, Paper, Box } from "@material-ui/core";
import MentorFillupFormD from "./MentorFillupFormD";

import { initGA, logPageView } from "../../analytics";
import { useState } from "react";

import { VIEW_MENTOR_APPLICATION_DATA } from "../common/constants/ApplicationUrl";

import api from "../common/dependencies/utils/Api";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
  button: {
    // #47558
    leftbutton: {
      marginRight: theme.spacing(1),
      backgroundColor: "#3AC2D7",
      color: "#fff",
      width: "150px",
    },
    rightbutton: {
      marginRight: "8px",
      backgroundColor: "#f4f4f4",
      border: "1 solid #000",
      width: "150px",
    },
  },
  textFieldRoot: {
    // // this will be applied when hovered (input text color change)
    // "&:hover": {
    //   color: theme.palette.secondary.main,
    // },
    // // this will applied when hovered (input border color change)
    // "&:hover $textFieldNotchedOutline": {
    //   borderColor: theme.palette.secondary.main
    // },
    // this will be applied when focused (input border color change)
    "&$textFieldFocused $textFieldNotchedOutline": {
      borderColor: "orange",
    },
  },
}));
const MentorForm = (props) => {
  
  
  
  // 
  
  const [applicationStatus, setApplicationStatus] = useState("");

  const classes = useStyles();
  useEffect(() => {
    // to call the initialise google analytics funtion
    try {
      initGA();
      window.GA_INITIALIZED = true;
      // to save the number og visitors on this side
      logPageView();
    } catch (error) {}
  }, [window]);
  const { getMentorForms, mentorFormList } = props;
  useEffect(() => {
    // getMentorForms();

    let value = localStorage.getItem("SavedLoggedInData");
    let LoginFormData = JSON.parse(value);
    if (localStorage.getItem("loggedIn") === "true") {
      const params = {
        id: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      };
      api
        .POST(`${VIEW_MENTOR_APPLICATION_DATA}`, params)
        .then((response) => {
          const { data, status } = response || {};
          if (status === 200) {
            
            if (response.data.data) {
              const responseData = response.data.data;
              if (responseData.role == "Mentor") {
                // alert(LoginFormData?.applicationStatus)
                setApplicationStatus(responseData.applicationStatus);
              }
            } else {
              setApplicationStatus(LoginFormData?.applicationStatus);
            }
          }
        })
        .catch((e) => {});
    } else {
      history.push("/login");
    }
  }, [getMentorForms]);

  const history = useHistory();
  const gotoDashboard = () => {
    history.push("./dashboard");
  };
  return (
    <div
      // style={{ paddingTop: "70px" }}
      style={{
        marginTop: "75px",
        paddingTop: "25px",
        paddingBottom: "20px",
        // backgroundColor:"#000",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundImage:
          "linear-gradient(119deg, #D2D8ED 0%, #EFF9FD 53%, #ffffff 100%)",
        // backgroundImage: `url(${formbg})`,
      }}
      className="mainformdivmentor"
    >
      {/* {(applicationStatus === "VERIFIED" ||
        applicationStatus === "REQUESTINFO") && (
        <div
          className=""
          style={{ marginRight: "85px", marginTop: "10px", height: "40px" }}
        >
          <div className="newUserTooltip">
            <div className="right-close" onClick={() => history.goBack()}>
              <img src={applyIcon} />{" "}
              <span className="tooltiptext tooltip-bottom">Close</span>
            </div>
          </div>
        </div>
       
      )} */}
      <div
        className=""
        style={{ marginRight: "85px", marginTop: "10px", height: "40px" }}
      >
        <div className="newUserTooltip">
          <div
            className="right-close2"
            onClick={() =>
              history.push({
                pathname: "/dashboard",
                // state: "cohortForm",
              })
            }
          >
            <img src={applyIcon} />{" "}
            <span className="tooltiptext tooltip-bottom">Close</span>
          </div>
        </div>
      </div>
      {applicationStatus === "SUBMITTED" ? (
        <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
          <h2 style={{ padding: "10px" }}>
            <p
              className="form-heading-style-bold"
              style={{ paddingBottom: "15px" }}
            >
              {" "}
              {applicationStatus === "VERIFIED"
                ? "You Are Already A Mentor"
                : // applicationStatus === "SUBMITTED"
                  // ? "You Already Submitted Application"
                  // :

                  ""}{" "}
            </p>
          </h2>
          {/* <Button
            className={classes.button}
            variant="contained"
            color="primary"
            style={{
              // marginRight: theme.spacing(1),
              backgroundColor: "#3AC2D7",
              color: "#fff",
              width: "200px",
              marginTop: "20px",
            }}
            onClick={() => gotoDashboard()}
          >
            Go to Dashboard
          </Button> */}
        </div>
      ) : applicationStatus === "PENDING" || applicationStatus === "" ? (
        <div>
          <p className="formHeadingCohortForm homepageSecondHeader"> MAARG Portal by Startup India </p>
          <h2>
            <p
              className={clsx("formHeadingMentorFormPurple", 'homepageFirstHeader')}
              // style={{ paddingTop: "15px" }}
            >
              Mentor Application Form{" "}
            </p>
          </h2>
          <CssBaseline />
          <Container component={Box}>
            <Paper component={Box}>
              <MentorFillupForm
                action={
                  props.location.action && props.location.action
                    ? props.action
                    : ""
                }
                data={
                  props.location.state && props.location.state
                    ? props.location.state
                    : ""
                }
              />
            </Paper>
          </Container>
          {/* <div className="formgraphicdiv"></div> */}
        </div>
      ) : (
        <div>
          <p className="form-heading2"> MAARG Portal by Startup India </p>
          <h2>
            <p
              className="form-heading-style-bold"
              // style={{ paddingTop: "15px" }}
            >
              Mentor Application Form{" "}
            </p>
          </h2>
          <CssBaseline />
          <Container component={Box} p={0}>
            <Paper component={Box} p={0}>
              <MentorFillupForm
                action={
                  props.location.action && props.location.action
                    ? props.location.action
                    : ""
                }
                data={props.state && props.state ? props.state : ""}
              />
            </Paper>
          </Container>
          <div className="formgraphicdiv"></div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  //
  //
  // return {
  //   mentorFormList: state.GetMentorFormReducer.getMentorFormList,
  // };
};
export default connect(mapStateToProps)(withRouter(MentorForm));

// export default MentorForm;
